const classToggles = document.querySelectorAll("[data-toggle-class]");
classToggles.forEach((toggle) => {
    toggle.addEventListener("click", (e) => {
        e.preventDefault();
        performToggle(toggle);
    });
});

function performToggle(toggle) {
    const className = toggle.dataset.toggleClass || "";
    const id = toggle.getAttribute("href").replace("#", "");
    const el = document.getElementById(id);

    el?.classList.toggle(className);
    el?.classList.add("transitioning");

    window.setTimeout(() => {
        el?.classList.remove("transitioning");
    }, 300);
}
